import { render, staticRenderFns } from "./SetEmailAndPassword.vue?vue&type=template&id=b9fe60d6&scoped=true"
import script from "./SetEmailAndPassword.vue?vue&type=script&lang=js"
export * from "./SetEmailAndPassword.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b9fe60d6",
  null
  
)

export default component.exports